import { BCMSAsset } from "@bcm-dev/bcms-vite";

// SVG Imports
import ArrowDownIcon from "res/img/ArrowDownIcon.svg?react";
import BankIcon from "res/img/BankIcon.svg?react";
import CheckPenIcon from "res/img/CheckPenIcon.svg?react";
import CheckmarkBadgeIcon from "res/img/CheckmarkBadgeIcon.svg?react";
import CircleDollarSignIcon from "res/img/CircleDollarSignIcon.svg?react";
import ClockArrowIcon from "res/img/ClockArrowIcon.svg?react";
import ClockIcon from "res/img/ClockIcon.svg?react";
import ConfirmIcon from "res/img/ConfirmIcon.svg?react";
import DocumentIcon from "res/img/DocumentIcon.svg?react";
import DragDropIcon from "res/img/DragDropIcon.svg?react";
import EditIcon from "res/img/EditIcon.svg?react";
import EllipsisIcon from "res/img/EllipsisIcon.svg?react";
import EnvelopeIcon from "res/img/EnvelopeIcon.svg?react";
import ExclamationMarkIcon from "res/img/ExclamationMarkIcon.svg?react";
import EyeIcon from "res/img/EyeIcon.svg?react";
import HeadsetIcon from "res/img/HeadsetIcon.svg?react";
import HelpOutlineIcon from "res/img/HelpOutlineIcon.svg?react";
import HideEyeIcon from "res/img/HideEyeIcon.svg?react";
import KeyIcon from "res/img/KeyIcon.svg?react";
import LeftArrowIcon from "res/img/LeftArrowIcon.svg?react";
import LightningIcon from "res/img/LightningIcon.svg?react";
import ListIcon from "res/img/ListIcon.svg?react";
import LocationPinIcon from "res/img/LocationPinIcon.svg?react";
import MinusMagnifyingGlassIcon from "res/img/MinusMagnifyingGlassIcon.svg?react";
import MobilePhoneIcon from "res/img/MobilePhoneIcon.svg?react";
import PencilIcon from "res/img/PencilIcon.svg?react";
import PiggyBankDollarSignIcon from "res/img/PiggyBankDollarSignIcon.svg?react";
import PiggyBankIcon from "res/img/PiggyBankIcon.svg?react";
import PlusIcon from "res/img/PlusIcon.svg?react";
import PlusMagnifyingGlassIcon from "res/img/PlusMagnifyingGlassIcon.svg?react";
import ProfileIcon from "res/img/ProfileIcon.svg?react";
import QuestionMarkCircleIcon from "res/img/QuestionMarkCircleIcon.svg?react";
import RightArrowIcon from "res/img/RightArrowIcon.svg?react";
import ShareIcon from "res/img/ShareIcon.svg?react";
import SilentBellIcon from "res/img/SilentBellIcon.svg?react";
import SortIcon from "res/img/SortIcon.svg?react";
import SquareMessageBubbleIcon from "res/img/SquareMessageBubbleIcon.svg?react";
import SquareProfileIcon from "res/img/SquareProfileIcon.svg?react";
import TrashcanXIcon from "res/img/TrashcanXIcon.svg?react";
import WiresIcon from "res/img/WiresIcon.svg?react";
import AlertTriangleIcon from "res/img/alert-triangle-icon.svg?react";
import ArrowUpIcon from "res/img/arrow-up-icon.svg?react";
import BarChartIcon from "res/img/bar-chart-icon.svg?react";
import BellIcon from "res/img/bell-icon.svg?react";
import CalendarIcon from "res/img/calendar-icon.svg?react";
import CameraIcon from "res/img/camera-icon.svg?react";
import CardIcon from "res/img/card-icon.svg?react";
import ChatIcon from "res/img/chat-icon.svg?react";
import CheckListIcon from "res/img/check-list-icon.svg?react";
import CircleCheckmarkIcon from "res/img/circle-checkmark-icon.svg?react";
import CircleProfileIcon from "res/img/circle-profile-icon.svg?react";
import CircleQuestionMarkIcon from "res/img/circle-question-mark-icon.svg?react";
import CloseX from "res/img/close-x.svg?react";
import CopyIcon from "res/img/copy-icon.svg?react";
import DollarSignOutlineIcon from "res/img/dollar-sign-outline-icon.svg?react";
import DownChevronIcon from "res/img/down-chevron-icon.svg?react";
import DownloadArrowIcon from "res/img/download-arrow-icon.svg?react";
import DropdownIcon from "res/img/dropdown-icon.svg?react";
import EqualHousing from "res/img/equal-housing.svg?react";
import GearIcon from "res/img/gear-icon.svg?react";
import GearOutlineIcon from "res/img/gear-outline-icon.svg?react";
import HamburgerMenuIcon from "res/img/hamburger-menu-icon.svg?react";
import HouseIcon from "res/img/house-icon.svg?react";
import InfoIcon from "res/img/info-icon.svg?react";
import KeypadButtonsIcon from "res/img/keypad-buttons-icon.svg?react";
import LeftChevronIcon from "res/img/left-chevron-icon.svg?react";
import LeftDoubleChevronIcon from "res/img/left-double-chevron-icon.svg?react";
import MagnifyingGlassIcon from "res/img/magnifying-glass-icon.svg?react";
import MessageBubbleIcon from "res/img/message-bubble-icon.svg?react";
import MonitorIcon from "res/img/monitor-icon.svg?react";
import MuteIcon from "res/img/mute-icon.svg?react";
import OpenDoorIcon from "res/img/open-door-icon.svg?react";
import PaperclipIcon from "res/img/paperclip-icon.svg?react";
import PhoneIcon from "res/img/phone-icon.svg?react";
import QuestionMarkMessageIcon from "res/img/question-mark-message-icon.svg?react";
import RightChevronIcon from "res/img/right-chevron-icon.svg?react";
import RightDoubleChevronIcon from "res/img/right-double-chevron-icon.svg?react";
import SendArrowIcon from "res/img/send-arrow-icon.svg?react";
import TransfersIcon from "res/img/transfers-icon.svg?react";
import UpChevronIcon from "res/img/up-chevron-icon.svg?react";
import VideoCameraIcon from "res/img/video-camera-icon.svg?react";
import WalletIcon from "res/img/wallet-icon.svg?react";
import XMessageBubbleIcon from "res/img/x-message-bubble-icon.svg?react";
import ZelleIcon from "res/img/zelle-icon.svg?react";

// IMG Imports
import CreditCardStackedIcon from "res/img/CreditCardStackedIcon.png";
import SignOutIcon from "res/img/SignOutIcon.png";
import AdobeAcrobatReaderPromoIcon from "res/img/adobe_acrobat_reader_promo.png";
import CheckBackOverlay from "res/img/back-overlay.png";
import CheckBackEndorsed from "res/img/check-back-endorsed.png";
import CheckBack from "res/img/check-back.png";
import CheckFrontFilledOut from "res/img/check-front-filled-out.png";
import CheckFront from "res/img/check-front.png";
import CreditScoreImage from "res/img/credit-score-image.png";
import FDICDigitalSignWhite from "res/img/fdic-digital-sign-white.png";
import FDICDigitalSign from "res/img/fdic-digital-sign.png";
import CheckFrontOverlay from "res/img/front-overlay.png";
import MobileUltraLogo from "res/img/mobile-ultra-logo.png";
import MyFinancialLogoWhite from "res/img/myFinancialLogo-white.png";
import NationalCreditIconLogoGraph from "res/img/national-credit-icon-logo-graph.png";
import SampleStatement from "res/img/sample-statement.png";
import SuperFinancialLogoGrey from "res/img/super-financial-logo-grey.png";
import TelecomSquareLogo from "res/img/telecom-square-logo.png";
const assets =  {
	// SVG Exports
	"ArrowDownIcon" : ArrowDownIcon,
	"BankIcon" : BankIcon,
	"CheckPenIcon" : CheckPenIcon,
	"CheckmarkBadgeIcon" : CheckmarkBadgeIcon,
	"CircleDollarSignIcon" : CircleDollarSignIcon,
	"ClockIcon" : ClockIcon,
	"ClockArrowIcon" : ClockArrowIcon,
	"ConfirmIcon" : ConfirmIcon,
	"DocumentIcon" : DocumentIcon,
	"DragDropIcon" : DragDropIcon,
	"EditIcon" : EditIcon,
	"EllipsisIcon" : EllipsisIcon,
	"EnvelopeIcon" : EnvelopeIcon,
	"EyeIcon" : EyeIcon,
	"HeadsetIcon" : HeadsetIcon,
	"HelpOutlineIcon" : HelpOutlineIcon,
	"HideEyeIcon" : HideEyeIcon,
	"KeyIcon" : KeyIcon,
	"LeftArrowIcon" : LeftArrowIcon,
	"LightningIcon" : LightningIcon,
	"ListIcon" : ListIcon,
	"LocationPinIcon" : LocationPinIcon,
	"MinusMagnifyingGlassIcon" : MinusMagnifyingGlassIcon,
	"MobilePhoneIcon" : MobilePhoneIcon,
	"PencilIcon" : PencilIcon,
	"PiggyBankDollarSignIcon" : PiggyBankDollarSignIcon,
	"PiggyBankIcon" : PiggyBankIcon,
	"PlusIcon" : PlusIcon,
	"PlusMagnifyingGlassIcon" : PlusMagnifyingGlassIcon,
	"ProfileIcon" : ProfileIcon,
	"QuestionMarkCircleIcon" : QuestionMarkCircleIcon,
	"ShareIcon" : ShareIcon,
	"SilentBellIcon" : SilentBellIcon,
	"SortIcon" : SortIcon,
	"SquareMessageBubbleIcon" : SquareMessageBubbleIcon,
	"SquareProfileIcon" : SquareProfileIcon,
	"TrashcanXIcon" : TrashcanXIcon,
	"WiresIcon" : WiresIcon,
	"AlertTriangleIcon" : AlertTriangleIcon,
	"ArrowUpIcon" : ArrowUpIcon,
	"BarChartIcon" : BarChartIcon,
	"BellIcon" : BellIcon,
	"CalendarIcon" : CalendarIcon,
	"CameraIcon" : CameraIcon,
	"CardIcon" : CardIcon,
	"ChatIcon" : ChatIcon,
	"CheckListIcon" : CheckListIcon,
	"CircleCheckmarkIcon" : CircleCheckmarkIcon,
	"CircleProfileIcon" : CircleProfileIcon,
	"CircleQuestionMarkIcon" : CircleQuestionMarkIcon,
	"CloseX" : CloseX,
	"CopyIcon" : CopyIcon,
	"DollarSignOutlineIcon" : DollarSignOutlineIcon,
	"DownChevronIcon" : DownChevronIcon,
	"DownloadArrowIcon" : DownloadArrowIcon,
	"DropdownIcon" : DropdownIcon,
	"EqualHousing" : EqualHousing,
	"ExclamationMarkIcon" : ExclamationMarkIcon,
	"GearIcon" : GearIcon,
	"GearOutlineIcon" : GearOutlineIcon,
	"HamburgerMenuIcon" : HamburgerMenuIcon,
	"HouseIcon" : HouseIcon,
	"InfoIcon" : InfoIcon,
	"KeypadButtonsIcon" : KeypadButtonsIcon,
	"LeftChevronIcon" : LeftChevronIcon,
	"LeftDoubleChevronIcon" : LeftDoubleChevronIcon,
	"MagnifyingGlassIcon" : MagnifyingGlassIcon,
	"MessageBubbleIcon" : MessageBubbleIcon,
	"MonitorIcon" : MonitorIcon,
	"MuteIcon" : MuteIcon,
	"OpenDoorIcon" : OpenDoorIcon,
	"PaperclipIcon" : PaperclipIcon,
	"PhoneIcon" : PhoneIcon,
	"QuestionMarkMessageIcon" : QuestionMarkMessageIcon,
	"RightArrowIcon" : RightArrowIcon,
	"RightChevronIcon" : RightChevronIcon,
	"RightDoubleChevronIcon" : RightDoubleChevronIcon,
	"SendArrowIcon" : SendArrowIcon,
	"TransfersIcon" : TransfersIcon,
	"UpChevronIcon" : UpChevronIcon,
	"VideoCameraIcon" : VideoCameraIcon,
	"WalletIcon" : WalletIcon,
	"XMessageBubbleIcon" : XMessageBubbleIcon,
	"ZelleIcon" : ZelleIcon,

	// IMG Exports
	"AdobeAcrobatReaderPromoIcon": AdobeAcrobatReaderPromoIcon,
	"SignOutIcon" : SignOutIcon,
	"CheckBackEndorsed" : CheckBackEndorsed,
	"CheckBack" : CheckBack,
	"CheckFrontFilledOut" : CheckFrontFilledOut,
	"CheckFront" : CheckFront,
	"CheckFrontOverlay" : CheckFrontOverlay,
	"CheckBackOverlay" : CheckBackOverlay,
	"CreditCardStackedIcon" : CreditCardStackedIcon,
	"CreditScoreImage" : CreditScoreImage,
	"MobileUltraLogo" : MobileUltraLogo,
	"MyFinancialLogoWhite" : MyFinancialLogoWhite,
	"NationalCreditIconLogoGraph" : NationalCreditIconLogoGraph,
	"SampleStatement" : SampleStatement,
	"SuperFinancialLogoGrey" : SuperFinancialLogoGrey,
	"TelecomSquareLogo" : TelecomSquareLogo,
	"FDICDigitalSignWhite" : FDICDigitalSignWhite,
	"FDICDigitalSign" : FDICDigitalSign 
}
const { image, svg } = BCMSAsset.init(assets).loadAsset();

// Export a function for images
export function ImageAsset(props){ 
	return (<> { image(props.id, props) } </>); 
}

// Export a function for svgs
export function SVGAsset(props){ 
	if(assets[props.id]){
		return (<> { svg(props.id, { ...props, className: `${ props.className ?? "" } icon` }) } </>); 
	}

	return <span className={"icon "+(props.className?props.className:"material-symbols-outlined  material-icon-outlined md-14")}>{props.id}</span>
	
}